import type { ReactElement } from 'react'
import { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import ModalContext from 'contexts/ModalContext'
import LoyaltyEsimDetailsModal from 'loyalty/components/LoyaltyEsimDetailsModal'

interface Props {
  layout: 'tile' | 'row'
  benefit: App.LoyaltyBenefit
  benefitLabel: ReactElement
}

function LandingPageLoyaltyEsimPackage(props: Props) {
  const { layout, benefit, benefitLabel } = props
  const showModal = useContext(ModalContext)
  const intl = useIntl()

  const gbAmount = benefit.value?.unit === 'GB' ? benefit.value.amount : 0

  const heading = intl.formatMessage(
    {
      defaultMessage: '{amount} GB Free International Data',
      id: 'oTKHBJeWGL-bar8FwzXj',
      description: 'Heading for eSIM benefit tile on account landing page',
    },
    { amount: gbAmount || '-' },
  )

  const handleDetailsClick = useCallback(() => {
    showModal(<LoyaltyEsimDetailsModal />)
  }, [showModal])

  return <LandingPageLoyaltyBenefitTile
    layout={layout}
    benefitType="esim_package"
    heading={heading}
    subtitle={benefitLabel}
    onClick={handleDetailsClick}
  />
}

export default LandingPageLoyaltyEsimPackage
